export class TokenResponseModel {
    public token: string;
    public errors: string[];

    public constructor({ token, errors }: { token: string, errors: string[] }) {
        this.token = token;
        this.errors = errors ?? [];
    }
}